import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/homepage/index.vue";
import Loginpage from "../views/LoginView.vue";
import signIn from "../views/signIn.vue";
import ForgotPassword from "../views/ForgotPassword.vue";

Vue.use(VueRouter);

const routes = [
  // 登录
  // {
  //   path: "",
  //   name: "home",
  //   component: Login,
  // },
  {
    path: "",
    name: "home",
    component: () => import("../views/shouye/indexStu.vue"),
  },
  {
    path: "/Loginpage",
    name: "Loginpage",
    component: Loginpage,
  },
  // 注册
  {
    path: "/signIn",
    name: "signIn",
    component: signIn,
  },
  // 忘记密码
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  // 首页
  {
    path: "/homepage",
    name: "homepage",
    component: () => import("../views/homepage/index.vue"),
  },
  // 首页
  {
    path: "/three",
    name: "three",
    component: () => import("../views/three/index.vue"),
  },
  // 首页
  {
    path: "/deep",
    name: "deep",
    component: () => import("../views/deep/index.vue"),
  },
  {
    path: "/show",
    name: "show",
    component: () => import("../views/three/show.vue"),
  },
  // 实验中心--实验列表学生端
  {
    path: "/shouyeStu",
    name: "shouyeStu",
    component: () => import("../views/shouye/indexStu.vue"),
  },
  // 实验中心--实验列表教师端
  {
    path: "/shouye",
    name: "shouye",
    component: () => import("../views/shouye/indexTeacher.vue"),
  },
  // 实验中心--实验列表--实验详情学生端
  {
    path: "/shiyanStu",
    name: "shiyanStu",
    component: () => import("../views/shiyan/indexStu.vue"),
  },
  // 实验中心--实验列表--实验详情教师端
  {
    path: "/shiyan",
    name: "ShiYan",
    component: () => import("../views/shiyan/indexTeacher.vue"),
  },
  // 实验中心--实验编辑
  {
    path: "/expbianji",
    name: "expbianji",
    component: () => import("../views/shouye/indexchange.vue"),
  },
  //实验中心--实验编辑--编辑实验
  {
    path: "/bianji",
    name: "bianji",
    component: () => import("../views/shouye/bianji.vue"),
  },
  // 实验中心--实验统计
  {
    path: "/tongji",
    name: "tongji",
    component: () => import("../views/shouye/tongji.vue"),
  },
  //实验中心-- 实验记录
  {
    path: "/jilu",
    name: "jilu",
    component: () => import("../views/shouye/jilu.vue"),
  },
  //课程中心--课程列表
  {
    path: "/videopage",
    name: "videopage",
    component: () => import("../views/zaixiankecheng/videopage.vue"),
  },
  //课程中心--课程列表--课程详情学生
  {
    path: "/videoxiangqingStu",
    name: "videoxiangqingStu",
    component: () => import("../views/zaixiankecheng/videoxiangqingStu.vue"),
  },
  //课程中心--课程列表--课程详情
  {
    path: "/videoxiangqing",
    name: "videoxiangqing",
    component: () =>
      import("../views/zaixiankecheng/videoxiangqingTeacher.vue"),
  },
  //课程中心--课程编辑
  {
    path: "/videochange",
    name: "videochange",
    component: () => import("../views/zaixiankecheng/videochange.vue"),
  },
  // 课程中心--课程编辑--编辑课程实验
  {
    path: "/videobianji",
    name: "videobianji",
    component: () => import("../views/zaixiankecheng/videobianji.vue"),
  },
  //资源中心--实验资源
  {
    path: "/Resources",
    name: "Resources",
    component: () => import("../views/naturalResources/Resources.vue"),
  },
  //资源中心--课程资源
  {
    path: "/videores",
    name: "videores",
    component: () => import("../views/resource/videores.vue"),
  },
  //管理中心--编辑管理
  {
    path: "/myclass",
    name: "myclass",
    component: () => import("../views/class/index.vue"),
  },
  //管理中心--考核管理--题库管理
  {
    path: "/tiKu",
    name: "tiKu",
    component: () => import("../views/tiKu/index.vue"),
  },
  //管理中心--考核管理--试卷管理
  {
    path: "/shijuan",
    name: "shijuan",
    component: () => import("../views/shijuan/index.vue"),
  },
  //管理中心--考核管理--考试管理
  {
    path: "/kaoshi",
    name: "kaoshi",
    component: () => import("../views/kaoshi/index.vue"),
  },
  //管理中心--考核管理--成绩管理
  {
    path: "/chengji",
    name: "chengji",
    component: () => import("../views/chengji/index.vue"),
  },
  //消息中心--回复我的
  {
    path: "/huifu",
    name: "huifu",
    component: () => import("../views/message/huifu.vue"),
  },
  //消息中心--通知公告
  {
    path: "/tongzhi",
    name: "tongzhi",
    component: () => import("../views/message/tongzhi.vue"),
  },
  //消息中心--预约通知
  {
    path: "/yuyue",
    name: "yuyue",
    component: () => import("../views/message/yuyue.vue"),
  },
  //消息中心--评论中心审核
  {
    path: "/pinglun",
    name: "pinglun",
    component: () => import("../views/personalCenter/pinglun.vue"),
  },
  //消息中心--新闻资讯
  {
    path: "/xinwen",
    name: "xinwen",
    component: () => import("../views/message/xinwen.vue"),
  },

  {
    path: "/indexdown",
    name: "indexdown",
    component: () => import("../views/shiyan/indexdown.vue"),
  },

  //个人中心
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("../views/personalCenter/personalCenter.vue"),
  },
  //个人中心_收藏
  {
    path: "/shoucang",
    name: "shoucang",
    component: () => import("../views/personalCenter/shoucang.vue"),
  },
  {
    path: "/jiluadmin",
    name: "jiluadmin",
    component: () => import("../views/personalCenter/jilu.vue"),
  },
  {
    path: "/baobiao",
    name: "baobiao",
    component: () => import("../views/personalCenter/baobiao.vue"),
  },
  {
    path: "/chatMain",
    name: "chatMain",
    component: () => import("../views/personalCenter/chatMain.vue"),
  },
  {
    path: "/shiyanyuyue",
    name: "shiyanyuyue",
    component: () => import("../views/personalCenter/shiyanyuyue.vue"),
  },

  //学生考核中心
  {
    path: "/student_assess",
    name: "student_assess",
    component: () => import("../views/studentpage/student_assess.vue"),
  },

  // 在线课程管理
  {
    path: "/videonav",
    name: "videonav",
    component: () => import("../views/daohanglan/videonav.vue"),
  },

  // 测试接口界面
  {
    path: "/testUrl",
    name: "testUrl",
    component: () => import("../views/testUrl/testurl.vue"),
  },
  // 测试接口界面
  {
    path: "/testexp",
    name: "testexp",
    component: () => import("../views/testUrl/testexp.vue"),
  },
  // 实验统计
  {
    path: "/teacherShiyanshi",
    name: "teacherShiyanshi",
    component: () => import("../views/smartTeaching/teacherShiyanshi.vue"),
  },

  {
    path: "/testweb",
    name: "testweb",
    component: () => import("../views/message/test.vue"),
  },
  // 课程详情页面
  {
    path: "/onlineCourse",
    name: "onlineCourse",
    component: () => import("../views/zaixiankecheng/onlineCourse.vue"),
    // meta: { showNavbar: true }, // 显示导航栏
  },
  // {
  //   path: '/teacherShiyanshi',
  //   name: 'teacherShiyanshi',
  //   component: () => import('../views/smartTeaching/teacherShiyanshi.vue')
  // },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // console.log(localStorage.getItem("roles"));

  // if (to.path === "/"&&localStorage.getItem("roles")!="visiter"&&localStorage.getItem("roles")!="学生") {
  //   next("/homepage");
  // } else {
  //   next();
  // }
  if (to.path === "/" && localStorage.getItem("roles") != "visiter" && localStorage.getItem("roles") != "学生") {
    next("/homepage");
  } else if (to.path === "/homepage" && (localStorage.getItem("roles") == "学生" || localStorage.getItem("roles") == "visiter")) {
    next("/");
  } else if(to.path=='/homepage'&& !localStorage.getItem("roles")){
    localStorage.setItem('roles', 'visiter')
    next('/')
  }else {
    next();
  }
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
export default router;
